import './Footer.css';

interface outgoingLinkItem {
  name: string,
  link: string,
  order: number,
  isOnNavbar: boolean,
  isOnFooter: boolean
}

const Footer: React.FC<{outgoingLinks: outgoingLinkItem[]}> = (outgoingLinks) => {

  const links = outgoingLinks.outgoingLinks
  links.sort((a, b) => a.order - b.order);

  const NavBarMenuItem = (properties: {ItemName: string, ItemPath: string}) => {
    return (<a href={properties.ItemPath} key={properties.ItemName}>{properties.ItemName}</a>);
  }

  const buildNavBarMenuItems = () => {
    const items = [];
      for(let i = 0; i < links.length; i++) {
        if(links[i].isOnFooter) {
          const test = NavBarMenuItem({ItemName: links[i].name, ItemPath: links[i].link});
          items.push(test);
        }
      }
    return items;
  }

  return (
    <div className="Footer">

        <div className="FooterLogoContainer">
            <div className="FooterLogo">INTRA-HELSINKI</div>
        </div>

        <div className="FooterContent">
            {buildNavBarMenuItems()}
        </div>
        
    </div>
  );
};

export default Footer;